import React, { ReactNode } from 'react';
import { WhenInterface } from './WhenTypes';
import * as Styled from './WhenStyles';

interface WhenPropsInterface extends WhenInterface {
  children: ReactNode;
}

function When({ children, isShow, fullHeight }: WhenPropsInterface) {
  return (
    <Styled.When isShow={isShow} fullHeight={fullHeight}>
      {children}
    </Styled.When>
  );
}

export default When;
